/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CurrentTenancy } from '../models/CurrentTenancy';
import type { TenantInfo } from '../models/TenantInfo';
import type { TenantSwitchResponse } from '../models/TenantSwitchResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TenancyService {

    /**
     * List available tenancies for the user
     * Retrieves a list of all available tenancies that the authenticated user can access
     * @returns TenantInfo Success
     * @throws ApiError
     */
    public static listTenancies(): CancelablePromise<Array<TenantInfo>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tenancy',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Get current user tenancy information
     * Retrieves the current tenancy information for the authenticated user
     * @returns CurrentTenancy Success
     * @throws ApiError
     */
    public static getCurrentTenancy(): CancelablePromise<CurrentTenancy> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tenancy/current',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Switch to a specific tenant
     * Switches the user's current context to the specified tenant
     * @returns TenantSwitchResponse Successfully switched tenancy
     * @throws ApiError
     */
    public static switchTenancy({
        requestBody,
    }: {
        requestBody: {
            /**
             * The ID of the tenant to switch to
             */
            tenantId: string;
        },
    }): CancelablePromise<TenantSwitchResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/tenancy/current',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Return to home tenancy
     * Returns the user to their home/default tenancy context
     * @returns TenantSwitchResponse Successfully returned to home tenancy
     * @throws ApiError
     */
    public static resetTenancy(): CancelablePromise<TenantSwitchResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/tenancy/reset',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

}
